<template>
  <div class="gsl-hrm-forgot-password-container">
    <div class="gsl-hrm-forgot-password-wrapper">
      <div class="gsl-hrm-card-container">
        <oxd-text tag="h6" class="gsl-hrm-forgot-password-title">
          {{ $t('auth.reset_password') }}
        </oxd-text>
        <oxd-divider />
        <card-note
          :note-text="$t('auth.configured_receive_email_notification_note')"
          class="gsl-hrm-forgot-password-card-note"
          has-note-icon
        />
        <oxd-text class="gsl-hrm-forgot-password-reset">
          <oxd-text
            tag="span"
            class="gsl-hrm-forgot-password-reset--link"
            @click="navigateUrl"
          >
            {{ $t('general.click_here') }}
          </oxd-text>
          {{ $t('auth.back_to_login') }}
        </oxd-text>
      </div>
    </div>
    <slot name="footer"></slot>
  </div>
</template>

<script>
import CardNote from '../components/CardNote';
import {navigate} from '@ohrm/core/util/helper/navigation';
export default {
  name: 'EmailConfigurationWarning',
  components: {
    'card-note': CardNote,
  },
  methods: {
    navigateUrl() {
      navigate('/auth/login');
    },
  },
};
</script>
<style src="./reset-password.scss" lang="scss" scoped></style>
